module.exports = __webpack_public_path__ + "9e7c52ebaf4c13ebcef1349cfe5cb4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_20.jpg
// module id = 1701
// module chunks = 5